const FilterType = (state = {}, action) => {
  switch (action.type) {
    case 'SET_ALL_FILTER': {
      return {
        ...state,
        filters: action.payload,
      };
    }
    case 'APPLIED_FILTERS': {
      return {
        ...state,
        appliedFilter: action.appliedFilter || null,
      };
    }
    default: {
      return state;
    }
  }
};

export default FilterType;
